import {Outlet, createFileRoute} from '@tanstack/react-router';
import {RouteError} from 'shared';

import {ContentPendingPage} from '@/components/PendingPages/ContentPendingPage';

export const Route = createFileRoute('/_b/_p')({
  component: Outlet,
  errorComponent: RouteError,
  pendingComponent: ContentPendingPage,
});
